module.exports = __webpack_public_path__ + "img/thermometer-img5-1.6aacb45c.png";